<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="file_020"><img alt="Image" src="images/f0009-01.jpg"/></a></p><a id="file_020">
<p class="caption">º Dyed, carded wool. Clockwise from top left: blue Corriedale, blue Romney, green Romney, and blended merino.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_020.vue?6d29bdd4